import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { viewAmenitiesList } from "../../Redux/Actions/amenitiesActions";
import { columnsAmenities } from "../../Global Functions/columnsAntd";
import TableComponent from "../../Global Functions/tableComponents";

const ListAmenities = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  const dispatch = useDispatch();

  const { admin } = useSelector((state) => state.admin || {});
  const accessCode = admin?.data?.access_code || [];
  const canAdd = Array.isArray(accessCode) && accessCode.includes('add');
  const canEdit = Array.isArray(accessCode) && accessCode.includes('edit');

  const fetchAmenitiesDetails = useCallback(
    (page, pageSize) => {
      dispatch(
        viewAmenitiesList({
          page,
          limit: pageSize,
          filter: searchQuery,
        })
      );
    },
    [dispatch, searchQuery]
  );

  useEffect(() => {
    fetchAmenitiesDetails(pagination.current, pagination.pageSize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { amenities, loading } = useSelector((state) => state.amenities);

  useEffect(() => {
    if (amenities?.total) {
      setPagination((prevData) => ({ ...prevData, total: amenities.total }));
    }
  }, [amenities]);

  const handleTableChange = useCallback(
    (pagination) => {
      setPagination(pagination);
      fetchAmenitiesDetails(pagination.current, pagination.pageSize);
    },
    [fetchAmenitiesDetails]
  );

  const filterHandler = useCallback(() => {
    setPagination((prev) => ({ ...prev, current: 1 }));
    fetchAmenitiesDetails(1, pagination.pageSize);
  }, [fetchAmenitiesDetails, pagination.pageSize]);

  const columns = useMemo(() => columnsAmenities(canEdit), []);

  const dataSource = useMemo(
    () => (Array.isArray(amenities?.data) ? amenities.data : []),
    [amenities?.data]
  );

  return (
    <TableComponent
      h3heading="Amenities List"
      setState={setSearchQuery}
      filterFunction={filterHandler}
      buttonhead2={canAdd ? "Add Amenities" : null}
      navigateTo2={canAdd ? "/amenities/add" : null}
      dataSource={dataSource}
      pagination={pagination}
      onChange={handleTableChange}
      loading={loading}
      columns={columns}
    ></TableComponent>
  );
};

export default ListAmenities;
